import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable, map} from 'rxjs';
import {REMIT_BASE_URL} from './config';
import {RemitApiResponse} from './kyc/user-verification.service';
import {PaginationParams} from './remit-invoice.service';

export interface BeneficiaryProviderMonthlyUsage {
  id: string;
  transferMethod: string;
  bankCode: string;
  accountNumber: string;
  maxUsedCount: number;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
  version: string;
}

export interface CreateBeneficiaryProviderMonthlyUsageParams {
  transferMethod: string;
  bankCode: string;
  accountNumber: string;
  maxUsedCount?: number;
}

export interface UpdateBeneficiaryProviderMonthlyUsageParams {
  maxUsedCount: number;
}

export interface BeneficiaryProviderMonthlyUsages {
  message?: string;
  body: BeneficiaryProviderMonthlyUsage[];
  totalData: number;
}

export interface QueryBeneficiaryProviderMonthlyUsagesParams
extends PaginationParams {
  sortBy?: string | null;
  sortDirection?: 1 | -1 | null;
  transferMethod?: string | null;
  bankCode?: string | null;
  accountNumber?: string | null;
  maxUsedCount?: number | null;
}

export interface BeneficiaryProviderMonthlyUsageResponse {
  message: string;
  body: BeneficiaryProviderMonthlyUsage;
}

@Injectable({
  providedIn: 'root',
})
export class RemitBeneficiaryProviderMonthlyUsageService {
  constructor(
    private http: HttpClient,
    @Inject(REMIT_BASE_URL) private remitApiUrl: string,
  ) {}

  createBeneficiaryProviderMonthlyUsage(
      params: CreateBeneficiaryProviderMonthlyUsageParams,
  ): Observable<BeneficiaryProviderMonthlyUsageResponse> {
    return this.http.post<BeneficiaryProviderMonthlyUsageResponse>(
        `${this.remitApiUrl}/staff/beneficiary-provider-monthly-usage`,
        params,
    );
  }

  getBeneficiaryProviderMonthlyUsage(
      id: string,
  ): Observable<BeneficiaryProviderMonthlyUsage> {
    return this.http.get<BeneficiaryProviderMonthlyUsageResponse>(
        `${this.remitApiUrl}/staff/beneficiary-provider-monthly-usage/${id}`,
    ).pipe(map((response) => response.body));
  }

  queryBeneficiaryProviderMonthlyUsages(
      params: QueryBeneficiaryProviderMonthlyUsagesParams,
  ): Observable<BeneficiaryProviderMonthlyUsages> {
    return this.http.post<BeneficiaryProviderMonthlyUsages>(
        `${this.remitApiUrl}/staff/beneficiary-provider-monthly-usages`,
        params,
    );
  }

  updateBeneficiaryProviderMonthlyUsage(
      id: string,
      params: UpdateBeneficiaryProviderMonthlyUsageParams,
  ): Observable<RemitApiResponse> {
    return this.http.put<RemitApiResponse>(
        `${this.remitApiUrl}/staff/beneficiary-provider-monthly-usage/${id}`,
        params,
    );
  }
}
